<template>
  <div :class="cssClass">
    <v-container grid-list-sm fluid>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-container fluid grid-list-lg>
              <v-layout row class="prim_layout_tile">
                <v-flex md12 lg6 class="media_row">
                  <v-img
                    src="/static/img/project.jpg"
                    height="100%"
                    cover
                  ></v-img>
                </v-flex>
                <v-flex md12 lg6>
                  <div class="dpx-3">
                    <h1 class="ntb" v-text="projects.one[lang].title"></h1>
                    <div>
                      <div class="ffs lfs" v-text="projects.one[lang].excerpt"></div>
                      <div class="excert_second ffs lfs" v-text="projects.one[lang].excerpt2"></div>
                    </div>
                    <div>
                      <router-link :to="{ name: 'Seite', params: { slug: projects.one[lang].slug }}" class="lnk_more">
                        {{ translate['mehr_erfahren'][lang] }}
                      </router-link>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
          <v-card>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12 md6 lg4>
                  <v-card>
                    <router-link :to="{ name: 'Seite', params: { slug: projects.two[lang].slug }}" class="lnk_all">
                      <v-img
                        class="home_title"
                        height="400px"
                        src="/static/img/Rudolf_Mosse.jpg">
                        <v-container fill-height fluid>
                          <v-layout fill-height>
                            <v-flex xs12 align-end flexbox class="flex_media_tile_title">
                              <div class="media_tile_title">
                                <span v-html="projects.two[lang].title"></span>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-img>
                    </router-link>
                  </v-card>
                </v-flex>
                <v-flex xs12 md6 lg4>
                  <v-card>
                    <router-link :to="{ name: 'Seite', params: { slug: projects.three[lang].slug }}">
                      <v-img
                        class="a"
                        height="400px"
                        src="/static/img/collection.jpg">
                      <v-container fill-height fluid>
                          <v-layout fill-height>
                            <v-flex xs12 align-end flexbox class="flex_media_tile_title">
                              <div class="media_tile_title">
                                <span v-html="projects.three[lang].title"></span>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-img>
                    </router-link>
                  </v-card>
                </v-flex>
                <v-flex xs12 md6 lg4>
                  <v-card>
                    <router-link :to="'/rooms'">
                      <v-img
                        class="a"
                        height="400px"
                        src="/static/img/Mosse-Palais.jpg">
                        <v-container fill-height fluid>
                          <v-layout fill-height>
                            <v-flex xs12 align-end flexbox class="flex_media_tile_title">
                              <div class="media_tile_title">
                                <span v-html="projects.nine[lang].title"></span>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-img>
                    </router-link>
                  </v-card>
                </v-flex>

                <v-flex xs12 md6 lg4>
                  <v-card>
                    <router-link :to="{ name: 'Database'}">
                      <v-img
                        class="a"
                        height="400px"
                        src="/static/img/Kachelbild_Datenbank_01.jpg">
                        <v-container fill-height fluid>
                          <v-layout fill-height>
                            <v-flex xs12 align-end flexbox class="flex_media_tile_title">
                              <div class="media_tile_title">
                                <span v-html="projects.four[lang].title"></span>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-img>
                    </router-link>
                  </v-card>
                </v-flex>
                <v-flex xs12 md6 lg4>
                  <v-card>
                    <router-link :to="getQuellenPath">
                      <v-img
                        class="a"
                        height="400px"
                        src="/static/img/Startseiten_Kachel_02_edit01.jpg">
                        <v-container fill-height fluid>
                          <v-layout fill-height>
                            <v-flex xs12 align-end flexbox class="flex_media_tile_title">
                              <div class="media_tile_title">
                                <span v-html="projects.eight[lang].title"></span>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-img>
                    </router-link>
                  </v-card>
                </v-flex>
                <v-flex xs12 md6 lg4>
                  <v-card>
                    <router-link :to="projects.ten[lang].path">
                      <v-img
                        class="a"
                        height="400px"
                        src="/static/img/Kachelbild_Publikationen_01.jpg">
                        <v-container fill-height fluid>
                          <v-layout fill-height>
                            <v-flex xs12 align-end flexbox class="flex_media_tile_title">
                              <div class="media_tile_title">
                                <span v-html="projects.ten[lang].title"></span>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-img>
                    </router-link>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
          <v-card>
            <v-container fluid grid-list-lg mb-5 class="last_container">
              <v-layout row wrap>
                <v-flex xs12 md6 lg4>
                  <v-card height="100%">
                    <v-container fill-height fluid>
                      <v-layout fill-height class="home_tile_layout">
                        <v-flex xs12 align-end flexbox>
                          <div class="tile_title" v-html="projects.six[lang].title"></div>
                          <div class="tile_content" v-html="projects.six[lang].content"></div>
                          <div class="tile_logo">
                            <img src="/static/img/logos/Logo_FU.jpg" alt="Freie Universität Berlin">
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
                <v-flex xs12 md6 lg4>
                  <v-card height="100%">
                    <v-container fill-height fluid>
                      <v-layout fill-height class="home_tile_layout">
                        <v-flex xs12 align-end flexbox>
                          <div class="tile_title" v-html="projects.seven[lang].title"></div>
                          <div class="tile_logo_container">

                            <div class="tile_logo">
                              <a href="https://www.kulturstiftung.de/" target="_blank" rel="noopener">
                                <img src="/static/img/logos/Logo_KSL.png" alt="Kulturstiftung der Länder">
                              </a>
                            </div>
                            <div class="my-4 tile_logo">
                              <a href="https://www.kulturgutverluste.de/Webs/DE/Start/Index.html" target="_blank" rel="noopener">
                                <img src="/static/img/logos/Logo_DZK.png" alt="Deutsches Zentrum für Kulturgutverluste">
                              </a>
                            </div>
                            <div class="tile_logo">
                              <a href="http://mosseartproject.com/" target="_blank" rel="noopener">
                                <img src="/static/img/logos/Logo_MARP.png" alt="The Mosse Art Restitution Project">
                              </a>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
                <v-flex xs12 md12 lg4>
                  <v-card height="100%">
                    <v-container fill-height fluid>
                      <v-layout fill-height class="home_tile_layout">
                        <v-flex xs12 align-end flexbox>
                          <div class="tile_title" v-html="projects.five[lang].title"></div>
                          <ul class="partner mt-4">
                            <li v-for="(link, index) in projects.five[lang].links"
                              v-bind:key="'coop_' + index"
                              v-html="link"></li>
                          </ul>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Startseite',
  data () {
    return {
      msg: 'Mosse Art Research Initiative',
      cssClass: this.$options.name
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .toLowerCase(),
      projects: {
        one: {
          de: {
            about: 'Über das Projekt',
            title: 'Die Mosse Art Research Initiative (MARI)',
            excerpt: 'Im März 2017 hat die Mosse-Erbengemeinschaft zusammen mit der Freien Universität Berlin die Mosse Art Research Initiative (MARI) ins Leben gerufen. Das Forschungsvorhaben ist in vielerlei Hinsicht innovativ und von hoher kulturpolitischer Relevanz. Erstmals kooperieren deutsche Institutionen mit Nachfahren von Opfern der rassischen Verfolgung während des NS-Regimes in einer öffentlich-privaten Partnerschaft.',
            excerpt2: 'Die Initiative ging von der Kulturstiftung der Länder und der Stiftung Preußischer Kulturbesitz aus. Darüber hinaus sind zahlreiche Museen und Institutionen in die Forschung eingebunden. Zur Erfassung und Präsentation der komplexen Sachverhalte dient das effizient auf die Bedürfnisse der Provenienzforschung zugeschnittene MARI Online Portal. Als ein Netzwerk von höchster Kompetenz und Transparenz wird MARI wichtige Impulse für die zukünftige Wissensgenerierung zum Themenbereich der NS-verfolgungsbedingt entzogenen Kulturobjekte liefern, und darüber hinaus einen wertvollen Beitrag zur Gestaltung der Erinnerungskultur in Deutschland leisten.',
            slug: 'die-mosse-art-research-initiative-mari'
          },
          en: {
            about: 'About the Project',
            title: 'The Mosse Art Research Initiative (MARI)',
            excerpt: 'In March 2017, the Mosse community of heirs together with the Freie Universität Berlin founded the Mosse Art Research Initiative (MARI). This research project is innovative in many ways and very important in terms of cultural policy. For the first time, German institutions are cooperating with descendants of Nazi persecution in a public-private partnership. Kulturstiftung der Länder and Stiftung Preußischer Kulturbesitz took the initiative here. Furthermore, numerous museums and institutions have been included in the research project.',
            excerpt2: 'In order to examine and present the complex material, MARI Online Portal is efficiently custom-made for the needs of provenance research. As a network of the highest quality and transparency, MARI will provide important impulses for the future generation of knowledge on issues relating to objects that were confiscated under Nazi persecution and furthermore provide an important contribution to the shaping of the German culture of memory.',
            slug: 'the-mosse-art-research-initiative-mari'
          }
        },
        two: {
          de: {
            title: 'Rudolf Mosse<br>und seine Familie',
            slug: 'rudolf-mosse-und-seine-familie'
          },
          en: {
            title: 'Rudolf Mosse<br>and His Family',
            slug: 'rudolf-mosse-and-his-family'
          }
        },
        three: {
          de: {
            title: 'Rudolf Mosses Kunst&shy;sammlung',
            slug: 'rudolf-mosses-kunstsammlung'
          },
          en: {
            title: 'Rudolf Mosse’s Art Collection',
            slug: 'rudolf-mosses-art-collection'
          }
        },
        four: {
          de: {
            title: 'Daten&shy;bank'
          },
          en: {
            title: 'Data&shy;base'
          }
        },
        five: {
          de: {
            title: 'Kooperationspartner',
            links: [
              'Mosse Foundation (Erben nach Rudolf Mosse),<br>vertreten durch <a href="https://mosseartproject.com/" target="_blank" rel="noopener">MARP</a> und <a href="https://raue.com/" target="_blank" rel="noopener">Raue LLP</a><br>',
              '<a href="https://www.smb.museum/home.html" target="_blank" rel="noopener">Staatliche Museen zu Berlin / Stiftung Preußischer Kulturbesitz</a><br>',
              '<a href="https://www.smb.museum/museen-und-einrichtungen/zentralarchiv/home.html" target="_blank" rel="noopener">Zentralarchiv der Staatlichen Museen zu Berlin</a><br>',
              '<a href="https://www.jmberlin.de/" target="_blank" rel="noopener">Stiftung Jüdisches Museum Berlin</a><br>',
              '<a href="http://landesarchiv-berlin.de/" target="_blank" rel="noopener">Landesarchiv Berlin</a><br>',
              '<a href="https://www.kunsthalle-karlsruhe.de/" target="_blank" rel="noopener">Staatliche Kunsthalle Karlsruhe</a><br>',
              '<a href="https://www.stadt-koeln.de/leben-in-koeln/kultur/provenienzforschung" target="_blank" rel="noopener">Referat für Museumsangelegenheiten der Stadt Köln / Provenienzforschung</a><br>',
              '<a href="https://museum-wiesbaden.de/" target="_blank" rel="noopener">Museum Wiesbaden</a><br>',
              '<a href="https://wissenschaft.hessen.de/kultur/die-zentrale-stelle-fuer-provenienzforschung" target="_blank" rel="noopener">Zentralstelle für Provenienzforschung in Hessen</a><br>',
              '<a href="https://www.worms.de/de/tourismus/museen/museum-der-stadt/" target="_blank" rel="noopener">Museum der Stadt Worms</a><br>',
              '<a href="https://www.mathildenhoehe.eu/" target="_blank" rel="noopener">Intstitut Mathildenhöhe Darmstadt</a><br>',
              '<a href="https://www.meeresmuseum.de/" target="_blank" rel="noopener">Stiftung Deutsches Meeresmuseum Stralsund</a>',
              '<a href="http://www.duesseldorf.de" target="_blank" rel="noopener">Landeshauptstadt Düsseldorf, Kulturdezernat Provenienzforschung</a>'
            ]
          },
          en: {
            title: 'Cooperating Institutions',
            links: [
              'Mosse Foundation (Erben nach Rudolf Mosse),<br>represented by <a href="https://mosseartproject.com/" target="_blank" rel="noopener">MARP</a> and <a href="https://raue.com/" target="_blank" rel="noopener">Raue LLP</a>',
              '<a href="https://www.smb.museum/home.html" target="_blank" rel="noopener">Staatliche Museen zu Berlin / Stiftung Preußischer Kulturbesitz</a>',
              '<a href="https://www.smb.museum/museen-und-einrichtungen/zentralarchiv/home.html" target="_blank" rel="noopener">Zentralarchiv der Staatlichen Museen zu Berlin</a>',
              '<a href="https://www.jmberlin.de/" target="_blank" rel="noopener">Stiftung Jüdisches Museum Berlin</a>',
              '<a href="http://landesarchiv-berlin.de/" target="_blank" rel="noopener">Landesarchiv Berlin</a>',
              '<a href="https://www.kunsthalle-karlsruhe.de/" target="_blank" rel="noopener">Staatliche Kunsthalle Karlsruhe</a>',
              '<a href="https://www.stadt-koeln.de/leben-in-koeln/kultur/provenienzforschung" target="_blank" rel="noopener">Referat für Museumsangelegenheiten der Stadt Köln / Provenienzforschung</a>',
              '<a href="https://museum-wiesbaden.de/" target="_blank" rel="noopener">Museum Wiesbaden</a>',
              '<a href="https://wissenschaft.hessen.de/kultur/die-zentrale-stelle-fuer-provenienzforschung" target="_blank" rel="noopener">Zentralstelle für Provenienzforschung in Hessen</a>',
              '<a href="https://www.worms.de/de/tourismus/museen/museum-der-stadt/" target="_blank" rel="noopener">Museum der Stadt Worms</a>',
              '<a href="https://www.mathildenhoehe.eu/" target="_blank" rel="noopener">Intstitut Mathildenhöhe Darmstadt</a>',
              '<a href="https://www.meeresmuseum.de/" target="_blank" rel="noopener">Stiftung Deutsches Meeresmuseum Stralsund</a>',
              '<a href="http://www.duesseldorf.de" target="_blank" rel="noopener">Landeshauptstadt Düsseldorf, Kulturdezernat Provenienzforschung</a>'
            ]
          }
        },
        six: {
          de: {
            title: 'Mosse Art Research Initiative (MARI)',
            content: '<p>Kunst&shy;historisches Institut der Freien Universität Berlin<br>Koserstr. 20 Raum A.186 | 14195 Berlin<br>Tel.: +49 30 838 70338</p><p>Dr. Meike Hoffmann<br><a href="mailto:meike.hoffmann@fu-berlin.de" class="lnk_nodec">meike.hoffmann@fu-berlin.de</a></p>'
          },
          en: {
            title: 'Mosse Art Research Initiative (MARI)',
            content: '<p>Kunst&shy;historisches Institut der Freien Universität Berlin<br>Koserstr. 20 Raum A.186 | 14195 Berlin<br>Tel.: +49 30 838 70338</p>Dr. Meike Hoffmann<p><a href="mailto:meike.hoffmann@fu-berlin.de" class="lnk_nodec">meike.hoffmann@fu-berlin.de</a></p>'
          }
        },
        seven: {
          de: {
            title: 'Gefördert von'
          },
          en: {
            title: 'Funded  by'
          }
        },
        eight: {
          de: {
            title: 'Quellen',
            path: '/page/quellen'
          },
          en: {
            title: 'Sources',
            path: '/page/sources'
          }
        },
        nine: {
          de: {
            title: 'Mosse-Palais',
            path: '/rooms'
          },
          en: {
            title: 'Mosse-Palais',
            path: '/rooms'
          }
        },
        ten: {
          de: {
            title: 'Publikationen und Vorträge',
            path: '/page/vortraege-und-publikationen'
          },
          en: {
            title: 'Publications and Talks',
            path: '/page/talks-and-publikations'
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'posts',
      'translate',
      'lang'
    ]),
    getQuellenPath: function () {
      return this.projects.eight[this.lang].path
    }
  }
}
</script>
<style lang="scss">
.lfs {
  font-size: 1.25rem;
}
.tile_type {
  text-transform: uppercase;
  font-family: 'Conv_ApercuPro-Bold';
  font-size: 1.125rem;
}
.tile_title {
    font-size: 1rem;
    font-family: 'Conv_ApercuPro-Bold';
    letter-spacing: .1rem;
    font-style: normal;
}
.tile_content {
    font-size: 1.5rem;
    font-family: 'Freight-TextBook';
    font-weight: 200;
    line-height: 1.25;
    letter-spacing: .05rem;
    margin: 4rem 0 4rem 0;
    @media (max-width: 800px) {
      font-size: 1.1rem;
    }
    @media (max-width: 599px) {
      font-size: 1.5rem;
    }
}
.application .v-content a.lnk_more {
    font-family: 'Conv_ApercuPro-Bold';
    text-decoration: none;
    color: #6c07ff;
    letter-spacing: 0.05rem;
    padding-bottom: .25rem;
    border-bottom: 3px solid #6c07ff;
}
.flex_media_tile_title {
  position: relative;
}
.application .v-content .media_tile_title {
  color: #fff;
  position: absolute;
  bottom: 0.5rem;
  span, a {
    color: #fff;
    font-size: 2.5rem;
    font-family: 'Freight-TextBook';
    font-weight: 200;
    line-height: 1.25;
    letter-spacing: 0.15rem;
    text-decoration: none;
    @media (max-width: 800px) {
      font-size: 1.5rem;
    }
    @media (max-width: 599px) {
      font-size: 2.5rem;
    }
  }
}
.application .v-content h1.ntb {
  margin-top: 0;
}
@media (max-width: 1400px) {
  .excert_second {
    display: none;
  }
}
.home_title div {
  width: 100%;
}
.home_title .media_tile_title {
  width: auto;
}
.dpx-3 {
  padding-right: 16px;
  padding-left: 16px;
}
@media (max-width: 959px) {
  .container.grid-list-lg .prim_layout_tile .media_row {
    display: none;
  }
  .dpx-3 {
    padding-right: 0;
    padding-left: 0;
  }
}
.home_tile_layout {
  width: 100%;
}
.v-card .last_container {
  padding-top: 0;
}
.application .v-content .tile_logo {
  text-align: center;
  img {
    width: 100%;
    max-width: 356px;
  }
}
.lnk_nodec {
  text-decoration: none;
}
.tile_logo_container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction:column;
}
ul.partner {
  list-style: none;
  line-height: 1.25;
  li {
    margin-bottom: 0.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Startseite.vue